import { isNil } from 'lodash-es'
import { DateLike } from './types'

export function notNilFilter<T>(el: T | undefined | null): el is T {
  return !isNil(el)
}

export function aggregateAllOrNothing<T, R>(items: T[], valueGetter: (value: T) => R, defaultValue: R): R
export function aggregateAllOrNothing<T, R>(items: T[], valueGetter: (value: T) => R, defaultValue?: R): R | undefined
export function aggregateAllOrNothing<T, R>(items: T[], valueGetter: (value: T) => R, defaultValue: R | undefined = undefined) {
  if (items.length === 0) {
    return defaultValue
  }

  const firstItemValue = valueGetter(items[0])
  if (items.every(item => valueGetter(item) === firstItemValue)) {
    return firstItemValue
  }

  return defaultValue
}

export const compareDateDesc = (d1: DateLike, d2: DateLike): number => {
  if (d1 === null && d2 === null) return 0
  if (d1 === null) return 1
  if (d2 === null) return -1

  return d1 < d2 ? 1 : d1 > d2 ? -1 : 0
}

export function hasMultipleValues<T, R>(items: T[], valueGetter: (value: T) => R) {
  if (items.length === 0) {
    return false
  }
  const firstItemValue = valueGetter(items[0])

  return items.some(item => valueGetter(item) !== firstItemValue)
}

export function aggregateSum<T>(items: T[], valueGetter: (value: T) => number | null | undefined) {
  const result = items.reduce((acc, cur) => {
    const number = valueGetter(cur)

    if (number) {
      acc = acc + number
    }

    return acc
  }, 0)

  return result
}

export const movePrev = (elements: string[], element: string) => {
  return move(elements, element, -1)
}

export const moveNext = (elements: string[], element: string) => {
  return move(elements, element, 1)
}

const move = (elements: string[], element: string, delta: number) => {
  const currentIndex = elements.findIndex(e => e === element)
  const newIndex = currentIndex + delta

  if (newIndex < 0 || newIndex === elements.length) return elements

  const elementsUpdated = [...elements]
  elementsUpdated.splice(currentIndex, 1)
  elementsUpdated.splice(newIndex, 0, element)

  return elementsUpdated
}
